module.exports = __webpack_public_path__ + "static/block1-2d58d0e485c88843fd4a6ecd701a663d.jpg";